// Libs
import React from 'react';
// Hooks
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './LeftArrows';

const LeftArrowsIcon = ({ onClick, onlyIcon }) => {
	const { theme } = useTheme();

	return onlyIcon ? (
		<Icon fill={theme._mediumEmphasisColor} onClick={onClick} />
	) : (
		<IconButton onClick={onClick}>
			<Icon fill={theme._mediumEmphasisColor} />
		</IconButton>
	);
};

export default LeftArrowsIcon;
